module.exports = __webpack_public_path__ + "assets/img/companyicon4.fd5f4067.jpg";